import { NAVBAR } from "@config/testIds/navbar";

import { AVAILABLE_LANGS } from "@typings/globals";

import { Link } from "./useLangNav.types";

export const linksConfig: Record<
  AVAILABLE_LANGS,
  Omit<Link, "clickHandler" | "href">
> = {
  [AVAILABLE_LANGS.EN]: {
    code: AVAILABLE_LANGS.EN,
    label: "batmaid_pwa_generic.language_en",
    testId: NAVBAR.LANGUAGE_BUTTON_EN,
    eventId: "lang-en",
  },
  [AVAILABLE_LANGS.FR]: {
    code: AVAILABLE_LANGS.FR,
    label: "batmaid_pwa_generic.language_fr",
    testId: NAVBAR.LANGUAGE_BUTTON_FR,
    eventId: "lang-fr",
  },
  [AVAILABLE_LANGS.DE]: {
    code: AVAILABLE_LANGS.DE,
    label: "batmaid_pwa_generic.language_de",
    testId: NAVBAR.LANGUAGE_BUTTON_DE,
    eventId: "lang-de",
  },
  [AVAILABLE_LANGS.IT]: {
    code: AVAILABLE_LANGS.IT,
    label: "batmaid_pwa_generic.language_it",
    testId: NAVBAR.LANGUAGE_BUTTON_IT,
    eventId: "lang-it",
  },
  [AVAILABLE_LANGS.NL]: {
    code: AVAILABLE_LANGS.NL,
    label: "batmaid_pwa_generic.language_nl",
    testId: NAVBAR.LANGUAGE_BUTTON_NL,
    eventId: "lang-nl",
  },
  [AVAILABLE_LANGS.PL]: {
    code: AVAILABLE_LANGS.PL,
    label: "batmaid_pwa_generic.language_pl",
    testId: NAVBAR.LANGUAGE_BUTTON_PL,
    eventId: "lang-pl",
  },
};
